<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{ storeName }}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      学员管理
    </div>
    <div class="form">
      <el-form :model="ruleForm" ref="ruleForm" label-width="93px" label-position="right" class="demo-ruleForm">
        <div class="formBox">
          <el-form-item label="项目名称：">
            <el-select v-model="ruleForm.name" placeholder="请选择" @change="getStuList" style="width: 175px;">
              <el-option v-for="item in nameOptions" :key="item.id" :label="item.text" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否为导入学员：" label-width="135px">
            <el-select v-model="ruleForm.toLead" @change="getStuList" style="width: 175px">
              <el-option label="全部" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-select v-model="ruleForm.results" @change="getStuList" style="width: 175px;">
              <el-option label="全部" value="0"></el-option>
              <el-option label="已通过" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="未通过" value="3"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="formBox">
          <el-form-item label="导入时间：">
            <el-date-picker v-model="startDate" type="datetime" style="width:195px" value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择开始日期时间">
            </el-date-picker>
            <div class="timecen"></div>
            <el-date-picker v-model="endDate" type="datetime" style="width:195px" value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择结束日期时间">
            </el-date-picker>
          </el-form-item>
        </div>

      </el-form>
    </div>
    <div class="midbox">
      <div>
        <el-input placeholder="姓名/手机号/单位" prefix-icon="el-icon-search" class="cltinput"
          style="width: 240px;border-color: #0b8586;" v-model="clinput">
          <el-button style="background: #0B8586;padding:7px 21px;border:none;margin:0 -20px;color: #FFFEFE;"
            slot="append" @click="getStuList">搜索</el-button>
        </el-input>
        <div class="cltbtn" @click="isStuLead = true">导入</div>
      </div>
      <div class="mrbox">
        <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #0B8586;cursor: pointer;"
          @click="DownloadTemplate">人员导入模板下载</span>
        <div class="cltbtn" style="background: #CE1A1A">一键学分信息推送</div>
        <div class="cltbtn" @click="toexport" style="background: #AC3FB6">导出</div>
        <div class="cltbtn" style="background: #5590E8" @click="toAudit(1)">审核</div>
        <div class="cltbtn" style="background: #ADCB86" @click="toAudit(2)">驳回</div>
        <div class="cltbtn" @click="IsJoin = true" style="background: #0B8586">加入项目</div>
      </div>
    </div>
    <div class="listbox">
      <el-table :data="gridData" :row-key="getRowKey" @selection-change="handleSelectionChange">
        <el-table-column type="selection" fixed="left" :selectable="getselectable" :reserve-selection="true" width="42">
        </el-table-column>
        <el-table-column property="userName" label="姓名" width="80"></el-table-column>
        <el-table-column property="mobile" width="120" label="手机号"></el-table-column>
        <el-table-column property="educattext" width="90" label="学历"></el-table-column>
        <el-table-column property="admofftext" width="90" label="科室"></el-table-column>
        <el-table-column property="professtext" width="90" label="职称"></el-table-column>
        <el-table-column property="unit" width="160" label="单位"></el-table-column>
        <el-table-column property="" width="80" label="项目名称">
          <template slot-scope="scope">
            <span @click="showPro(scope.row.userId)" style="color:#0B8586;cursor: pointer;">查看详情</span>
          </template>
        </el-table-column>
        <el-table-column width="77" label="用户来源">
          <template slot-scope="scope">
            <span v-show="scope.row.u_Source == 1">导入</span>
            <span v-show="scope.row.u_Source == 2">申请</span>
          </template>
        </el-table-column>
        <el-table-column property="u_Type" width="77" label="用户状态">
          <template slot-scope="scope">
            <span v-show="scope.row.u_Type == 1">已绑定</span>
            <span v-show="scope.row.u_Type == 0">待审核</span>
            <span v-show="scope.row.u_Type == -1">已驳回</span>
          </template>
        </el-table-column>
        <el-table-column property="idCard" width="180" label="身份证号码"></el-table-column>
        <el-table-column property="isTcm" width="77" label="人员类别">
          <template slot-scope="scope">
            <span v-show="scope.row.isTcm == false">普通</span>
            <span v-show="scope.row.isTcm == true">中医</span>
          </template>
        </el-table-column>
        <el-table-column property="createDate" width="100" label="添加时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="70">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isTcm == false"
              @click.native.prevent="deleteRow(scope.row.userId, scope.row.userName)" type="text" size="small">
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex2"
          :page-sizes="[10, 30, 100, 300]" :page-size="pageSize2" layout="prev, pager, next,sizes,total" background
          :total="pageCount2">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="人员导入" :visible.sync="isStuLead" :closeOnClickModal="false" class="stuLead" width="576px">
      <el-form ref="form" :model="form" label-width="82px">
        <el-form-item label="项目名称：">
          <el-select v-model="form.name" placeholder="请选择" style="width: 390px;">
            <el-option v-for="item in nameOptions3" :key="item.id" :label="item.text" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员类别：">
          <el-select v-model="tcmpeopletypeid" placeholder="请选择" style="width: 390px;">
            <el-option v-for="item in tcmpeopleType" :key="item.id" :label="item.text" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="importItem">
          <el-form-item label="导入学员：" style="margin-bottom:0">
            <UploadExcel :on-success="uploadSuccess"></UploadExcel>
            <span v-show="form.userList.length == 0" style="font-size:12px;">已上传{{ form.userList.length }}人（上限{{
                tcmpeopletypeid != 2 ? numpeopleMax : tcmpeopleMax
            }}人）</span>
            <span v-show="form.userList.length <= numpeopleMax && form.userList.length > 0"
              style="font-size:12px;color:green">已上传{{ form.userList.length }}人（上限{{ tcmpeopletypeid != 2 ?
                  numpeopleMax : tcmpeopleMax
              }}人）</span>
            <span v-show="form.userList.length > numpeopleMax" style="font-size:12px;color:red">已上传{{
                form.userList.length
            }}人（上限{{ numpeopleMax }}人）</span>
          </el-form-item>
          <span
            style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #0B8586;cursor: pointer;line-height: 40px;"
            @click="DownloadTemplate">人员导入模板下载</span>
        </div>
        <span
          style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: red;line-height: 14px;">注：导入学员未注册全科医学网，用通用密码qkyx123456登录</span>
        <el-form-item>
          <div class="xzbtn" @click="toDown" v-loading="daorutext == '导入中'">{{ daorutext }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="'上传人员信息' + (StuLeadInfoErrNum > 0 ? '（存在' + StuLeadInfoErrNum + '条不合规数据）' : '')"
      :visible.sync="isStuLeadInfo" class="StuLeadResults" width="760px">
      <el-table :data="stuLeadInfoList" height="450px" :row-class-name="tableRowClassName" style="width: 100%">
        <el-table-column label="姓名" width="80">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex != scope.$index">{{ scope.row.userName }}</span>
            <input v-if="stuLeadInfoIndex == scope.$index" placeholder="请输入姓名"
              v-myfocus="scope.row.hint.indexOf('姓名') != -1" style="width:100%" v-model="scope.row.userName" />
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="130">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex != scope.$index">{{ scope.row.mobile }}</span>
            <input v-if="stuLeadInfoIndex == scope.$index" placeholder="请输入手机号"
              v-myfocus="scope.row.hint.indexOf('手机号') != -1" style="width:100%" v-model="scope.row.mobile" />
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex != scope.$index">{{ scope.row.unit }}</span>
            <input v-if="stuLeadInfoIndex == scope.$index" placeholder="请输入单位"
              v-myfocus="scope.row.hint.indexOf('单位') != -1" style="width:100%" v-model="scope.row.unit" />
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span style="color:red">{{ scope.row.hint }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
              {{ stuLeadInfoIndex == scope.$index ? '保存' : '修改' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="stuLeadInfoBtn">
        <div class="xzbtn" style="color:#000;background:#fff" @click="isStuLeadInfo = false">上一步</div>
        <div class="xzbtn" @click="submitForm">导入</div>
      </div>
    </el-dialog>
    <el-dialog :title="ResultsTitle + '完成'" :visible.sync="isStuLeadResults" class="StuLeadResults" width="576px">
      <div class="SLRTitle">
        <div :style="isSLR ? 'background-color: #fff;' : ''" @click="isSLR = true">查看{{ ResultsTitle }}成功人员信息（<span
            :style="isSLRList1.length > 0 ? 'color:green' : ''">{{ isSLRList1.length }}</span>）</div>
        <div :style="!isSLR ? 'background-color: #fff;' : ''" @click="isSLR = false">查看{{ ResultsTitle }}失败人员信息（<span
            :style="isSLRList2.length > 0 ? 'color:red' : ''">{{ isSLRList2.length }}</span>）</div>
      </div>
      <el-table :data="isSLR ? isSLRList1 : isSLRList2" height="459" style="width: 100%">
        <el-table-column prop="userName" label="姓名" width="80">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="unit" label="单位">
        </el-table-column>
        <el-table-column prop="hint" label="备注">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="IsJoin" class="stuLead Join" width="576px">
      <el-form label-width="82px">
        <el-form-item label="选择项目：">
          <el-select v-model="JoinProId" placeholder="请选择" style="width: 390px;">
            <el-option v-for="item in nameOptions2" :key="item.id" :label="item.text" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="xzbtn" @click="toJoin">确认</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="isProDetail" class="stuLead ProDetail" width="576px">
      <!-- <div v-show="ProDetailList.length>0">
        <p v-for="(item,index) in ProDetailList"
           :key="index">
          <span>项目</span>
          <span>{{index+1}}</span>
          <span>：</span>
          <span>{{item.proname}}</span>
        </p>
      </div>
      <div class="nolist"
           v-show="ProDetailList.length==0">该人员暂未加入项目</div> -->
      <el-button :type="isProDetailType == 1 ? 'primary' : ''" @click="isProDetailType = 1">机构项目</el-button>
      <el-button :type="isProDetailType == 2 ? 'primary' : ''" @click="isProDetailType = 2">CME课程</el-button>
      <el-table :data="isProDetailType == 1 ? ProDetailList : ProDetailList2" height="192px" style="width: 100%">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column :prop="isProDetailType == 1 ? 'proname' : 'pname'" label="项目名称">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import UploadExcel from '../components/UploadExcel/index.vue';
export default {
  components: {
    UploadExcel
  },
  name: 'student',
  data() {
    return {
      orgid: 0,
      storeName: '',
      numpeopleMax: '',
      tcmpeopleMax: '',
      tcmpeopleType: [{ text: '普通', id: 1 }, { text: '中医', id: 2 }],
      tcmpeopletypeid: '',
      IsTcm: false,
      ruleForm: {
        name: '',
        results: '0',
        toLead: '0'
      },
      startDate: '',
      endDate: '',
      gridData: [],
      clinput: '',
      pageCount2: 0,
      pageIndex2: 1,
      pageSize2: 10,
      nameOptions: [],
      nameOptions2: [],
      nameOptions3: [],
      isStuLead: false,
      form: {
        name: '',
        userList: []
      },
      isStuLeadResults: false,
      isSLR: true,
      isSLRList1: [],
      isSLRList2: [],
      IsJoin: false,
      JoinProId: '',
      peopleList: [],
      peopleIdList: [],
      ResultsTitle: '',
      u_TypeList: [],
      ProDetailList: [],
      ProDetailList2: [],
      isProDetail: false,
      isProDetailType: 1,
      clickUserId: '',
      daorutext: '下一步',
      isStuLeadInfo: false,
      StuLeadInfoErrNum: 0,
      stuLeadInfoList: [],
      stuLeadInfoIndex: -1
    };
  },
  created() {
    this.storeName = localStorage.getItem('storeName')
    if (localStorage.getItem('storeId')) {
      this.orgid = Number(localStorage.getItem('storeId'))
    }
    this.getProList()
    this.getStuList()
    this.getStoreDetail()
  },
  watch: {
    startDate: function (val) {
      if (val == null) {
        this.startDate = ''
      }
      this.getStuList()
    },
    endDate: function (val) {
      if (val == null) {
        this.endDate = ''
      }
      this.getStuList()
    }
  },
  methods: {
    getStuList() {
      this.httphelper.post('/api/EnterProjectApi/GetOrgUserPageList', {
        orgId: this.orgid,
        source: Number(this.ruleForm.toLead),
        userName: this.clinput,
        type: Number(this.ruleForm.results),
        proId: Number(this.ruleForm.name),
        startDate: this.startDate,
        endDate: this.endDate,
        page: Number(this.pageIndex2),
        limit: Number(this.pageSize2)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.pageCount2 = res.data.totalcount
            this.gridData = res.data.data
          }
        });
    },
    handleSizeChange(e) {
      if (e == this.pageSize2) {
        return;
      }
      this.pageSize2 = e;
      this.pageIndex2 = 1
      this.getStuList()
    },
    handleCurrentChange(e) {
      if (e == this.pageIndex2) {
        return;
      }
      this.pageIndex2 = e;
      this.getStuList()
    },
    handleSelectionChange(val) {
      this.u_TypeList = []
      for (let i = 0; i < val.length; i++) {
        this.u_TypeList.push({
          id: val[i].userId,
          u_Type: val[i].u_Type
        })
      }
      this.peopleIdList = []
      for (let i = 0; i < val.length; i++) {
        this.peopleIdList.push(val[i].userId)
      }
      this.peopleList = []
      for (let i = 0; i < val.length; i++) {
        this.peopleList.push({
          id: val[i].id,
          userName: val[i].userName,
          educattext: val[i].educattext,
          admofftext: val[i].admofftext,
          professtext: val[i].professtext,
          unit: val[i].unit,
          u_Source: val[i].u_Source == 1 ? '添加' : (val[i].u_Source == 2 ? '申请' : ''),
          u_Type: val[i].u_Type == -1 ? '已驳回' : (val[i].u_Source == 0 ? '待审核' : (val[i].u_Source == 1 ? '已绑定' : '')),
          idCard: val[i].idCard,
          createDate: val[i].createDate
        })
      }
    },
    getselectable(row) {
      return !row.isExist;
    },
    getRowKey(row) {
      return row.id
    },
    getProList() {
      this.httphelper.get('/api/EnterProjectApi/GetSelProgectList', {
        orgId: this.orgid
      })
        .then(res => {
          if (res.code == 200) {
            for (let i = 0; i < res.data.length; i++) {
              this.nameOptions.push(res.data[i])
              this.nameOptions2.push(res.data[i])
              this.nameOptions3.push(res.data[i])
            }
            this.nameOptions.unshift({
              text: "全部",
              id: 0
            })
            this.nameOptions3.unshift({
              text: "暂不选择",
              id: 0
            })
          }
        });
    },
    getPeopleProList() {
      this.httphelper.get('/api/EnterProjectApi/GetUserProjectList', {
        orgId: this.orgid,
        userId: Number(this.clickUserId)
      })
        .then(res => {
          if (res.code == 200) {
            this.ProDetailList = res.data
          }
        });
      this.httphelper.get('/api/CourseClassApi/GetUserLearprojPageList', {
        orgId: this.orgid,
        userId: Number(this.clickUserId),
        limit: 99
      })
        .then(res => {
          if (res.code == 200) {
            this.ProDetailList2 = res.data
          }
        });
    },
    getStoreDetail() {
      this.httphelper.get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
        id: this.orgid
      })
        .then(res => {
          if (res.code == 200) {
            this.numpeopleMax = res.data.numpeopleMax;
            this.tcmpeopleMax = res.data.tcmpeopleMax;
          }
        });
    },
    showPro(uid) {
      this.clickUserId = uid
      this.getPeopleProList()
      this.isProDetail = true
    },
    toDown() {

      if (this.form.name === '') return this.$message.error('请选择项目');
      if (this.tcmpeopletypeid === '') return this.$message.error('请选择人员类别');
      if (this.form.userList.length == 0) return this.$message.error('请上传人员');
      this.stuLeadInfoList = []
      this.StuLeadInfoErrNum = 0
      let reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      for (let i = 0; i < this.form.userList.length; i++) {
        let hint = ''
        if (this.form.userList[i].userName == '' && this.form.userList[i].mobile == '\r' && this.form.userList[i].unit == '') { } else {
          if (this.form.userList[i].userName == '') hint = hint + '姓名不能为空；'
          if (this.form.userList[i].mobile == '') hint = hint + '手机号不能为空；'
          if (!reg.test(this.form.userList[i].mobile.replace(/[^\d]/g, '')) && this.form.userList[i].mobile != '') hint = hint + '手机号格式错误；'
          if (this.form.userList[i].unit == '') hint = hint + '单位不能为空；'
          if (hint != '') this.StuLeadInfoErrNum++
          this.stuLeadInfoList.push({
            userName: this.form.userList[i].userName,
            mobile: this.form.userList[i].mobile,
            unit: this.form.userList[i].unit,
            hint: hint
          })
        }
      }
      this.isStuLeadInfo = true
    },
    handleEdit(index, item) {
      if (this.stuLeadInfoIndex == index) {
        let hint = ''
        let reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (this.stuLeadInfoList[index].userName == '') hint = hint + '姓名不能为空；'
        if (this.stuLeadInfoList[index].mobile == '') hint = hint + '手机号不能为空；'
        if (!reg.test(this.stuLeadInfoList[index].mobile.replace(/[^\d]/g, '')) && this.stuLeadInfoList[index].mobile != '') hint = hint + '手机号格式错误；'
        if (this.stuLeadInfoList[index].unit == '') hint = hint + '单位不能为空；'
        this.stuLeadInfoList[index].hint = hint
        this.StuLeadInfoErrNum = 0
        for (let i = 0; i < this.stuLeadInfoList.length; i++) {
          if (this.stuLeadInfoList[i].hint != '') this.StuLeadInfoErrNum++
        }
        this.stuLeadInfoIndex = -1
      } else {
        this.stuLeadInfoIndex = index
      }
    },
    submitForm() {
      if (this.tcmpeopletypeid == 2) { this.IsTcm = true } else { this.IsTcm = false }
      if (this.stuLeadInfoIndex != -1) return this.$message.error('有数据正在修改，请保存后导入！');
      if (this.StuLeadInfoErrNum > 0) return this.$message.error('存在不合规数据，请修正后导入！');
      this.isStuLeadInfo = false
      if (this.daorutext == '导入中') return this.$message.error('导入中');
      this.daorutext = '导入中'
      let arr = []
      for (let i = 0; i < this.stuLeadInfoList.length; i++) {
        arr.push({
          userName: this.stuLeadInfoList[i].userName,
          mobile: this.stuLeadInfoList[i].mobile,
          unit: this.stuLeadInfoList[i].unit,
        })
      }
      this.httphelper.post('/api/EnterProjectApi/ProgToleadUser', {
        progId: this.form.name,
        userlist: arr,
        orgId: this.orgid,
        isTcm: this.IsTcm
      })
        .then(res => {
          if (res.data.code == 200) {
            this.daorutext = '下一步'
            this.form.userList = ''
            this.isSLRList1 = res.data.data.succlist
            this.isSLRList2 = res.data.data.trylist
            this.ResultsTitle = '导入'
            this.isStuLead = false
            this.isStuLeadResults = true
            this.getStuList()
          }
        });
    },
    uploadSuccess({ results }) {
      // 如果是导入用户
      const userRelations = {
        '姓名': 'userName',
        '手机号': 'mobile',
        '单位': 'unit'
      }
      const arr = []
      let err = 0
      results.forEach((item, index) => {
        const userInfo = {}
        item.hasOwnProperty('姓名') == true ? '' : item['姓名'] = "";
        item.hasOwnProperty('手机号') == true ? '' : item['手机号'] = "";
        item.hasOwnProperty('单位') == true ? '' : item['单位'] = "";

        Object.keys(item).forEach(key => {
          if (userRelations[key] == undefined) {
            err++
            // return this.$message.error('当前Excel表的表头格式不符，建议下载模板使用');
          }
          userInfo[userRelations[key]] = item[key].toString()
        })
        arr.push(userInfo)
      })
      if (err > 0) return this.$message.error('当前Excel表的表头格式不符，建议下载模板使用');
      if (arr.length == 0) {
        this.$message.error('当前Excel表中没有数据或表头格式不符，建议下载模板使用');
      } else if (this.tcmpeopletypeid == 2 && arr.length > this.tcmpeopleMax) {
        this.$message.error('当前机构中医人数上限为' + this.tcmpeopleMax + '人，请勿超过上限');
      } else if (arr.length > this.numpeopleMax) {
        this.$message.error('当前机构人数上限为' + this.numpeopleMax + '人，请勿超过上限');
      } else {
        this.form.userList = arr
        this.$message.success('文件上传成功请点击下一步');
      }
    },
    DownloadTemplate() {
      const headers = {
        '姓名': 'userName',
        '手机号': 'mobile',
        '单位': 'unit'
      }
      import('@/assets/unit/Export2Excel').then(async excel => {
        // const res = await getUserList({ query: '', pagenum: 1, pagesize: this.page.total })
        let res = []
        const data = this.formatJson(headers, res)
        excel.export_json_to_excel({
          header: Object.keys(headers),
          data,
          filename: '人员导入模板',
          autoWidth: true,
          bookType: 'xlsx'

        })
      })
    },
    formatJson(headers, rows) {
      return rows.map(item => {
        return Object.keys(headers).map(key => {
          //   if (headers[key] === 'create_time') {
          //     return formatDate(item[headers[key]]) // formatDate 函数是定义好的一个过滤器
          //   }
          return item[headers[key]]
        })
      })
    },
    toJoin() {
      if (this.JoinProId == '') return this.$message.error('请选择项目');
      if (this.peopleIdList.length == 0) return this.$message.error('请勾选要加入项目的人员');
      this.httphelper.post('/api/EnterProjectApi/ProgAddUser', {
        proId: Number(this.JoinProId),
        userId: Number(JSON.parse(localStorage.getItem('ResData')).id),
        uidlist: this.peopleIdList,
        orgId: this.orgid
      })
        .then(res => {
          if (res.data.code == 200) {
            this.isSLRList1 = res.data.data.succlist
            this.isSLRList2 = res.data.data.trylist
            this.ResultsTitle = '加入'
            this.IsJoin = false
            this.isStuLeadResults = true
            this.getStuList()
          } else {
            this.$message.error('加入失败，请稍后再试！');
          }
        });
    },
    toexport() {
      const headers = {
        'ID': 'id',
        '姓名': 'userName',
        '学历': 'educattext',
        '科室': 'admofftext',
        '职称': 'professtext',
        '单位': 'unit',
        '来源': 'u_Source',
        '状态': 'u_Type',
        '身份证号码': 'idCard',
        '添加时间': 'createDate'
      }
      import('@/assets/unit/Export2Excel').then(async excel => {
        const data = this.formatJson(headers, this.peopleList)
        excel.export_json_to_excel({
          header: Object.keys(headers),
          data,
          filename: '机构人员表',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
      this.$message.success('导出成功');
    },
    toAudit(type) {
      let num = 0
      for (let a = 0; a < this.u_TypeList.length; a++) {
        if (this.u_TypeList[a].u_Type != 0) num++
      }
      if (num > 0 && type == 1) return this.$message.error('当前勾选的人员列表中包含' + num + '个审核完成人员，无法执行审核操作');
      if (num > 0 && type == 2) return this.$message.error('当前勾选的人员列表中包含' + num + '个审核完成人员，无法执行驳回操作');
      if (this.peopleIdList.length == 0) return this.$message.error('请勾选要审批的人员');
      this.httphelper.post('/api/EnterProjectApi/OrgUseraudit', {
        orgId: this.orgid,
        audittype: type,
        uidlist: this.peopleIdList
      })
        .then(res => {
          if (type == 1) {
            if (res.data.code == 200) this.$message.success('已成功审核通过' + this.peopleIdList.length + '个申请人员');
            else if (res.data.code == 201) this.$message.error('审核失败，人数超限');
            else this.$message.error('审核失败');
          }
          else if (type == 2) {
            if (res.data.code == 200) this.$message.success('已成功驳回' + this.peopleIdList.length + '个申请人员');
            else this.$message.error('驳回失败');
          }
          this.getStuList()
        });
    },
    deleteRow(id, name) {
      this.$confirm('确定要将' + name + '移出机构并同时将其移出所有项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper.post('/api/EnterProjectApi/DelOrgUser', {
          orgId: this.orgid,
          userId: Number(id)
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '移除成功!'
              });
              this.getStuList()
            } else if (res.data.code == 203) {
              this.$message({
                type: 'error',
                message: '已分配学分项目用户不可移除!'
              });
            } else {
              this.$message({
                type: 'error',
                message: '移除失败'
              });
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        });
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.hint != '') {
        return 'warning-row';
      }
      return '';
    }
  }
};
</script>

<style scoped>
.toptitle {
  width: 100%;
  box-sizing: border-box;
  height: 57px;
  background: #f6f7fb;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #0b8586;
  line-height: 56px;
  padding-left: 17px;
  margin: 30px 0 35px 0;
}

.formBox {
  display: flex;
  justify-content: space-between;
}

.form ::v-deep .el-form-item {
  margin-bottom: 0;
}

.form ::v-deep .el-input__inner {
  height: 30px;
}

.midbox ::v-deep .el-input__prefix {
  top: -4px;
}

.timecen {
  width: 9px;
  display: inline-block;
  height: 1px;
  background-color: #000000;
  margin: 0px 4px 5px 4px;
}

.midbox {
  padding: 20px 0;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.midbox ::v-deep .el-input__inner {
  height: 30px;
  border-color: #0b8586;
  border-right: none;
}

.midbox ::v-deep .el-input-group__append {
  border-color: #0b8586;
}

.cltbtn {
  height: 30px;
  background: #5db774;
  border-radius: 3px;
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fffefe;
  line-height: 30px;
  padding: 0 18px;
  display: inline-block;
  cursor: pointer;
}

.mrbox {
  display: flex;
  align-items: center;
}

.listbox {
  width: 973px;
}

.listbox ::v-deep th {
  background: #f6f7fb;
}

.listbox ::v-deep td {
  padding: 8px 0 !important;
}

.listbox ::v-deep .cell {
  text-align: center;
}

.stuLead ::v-deep .el-dialog {
  padding: 50px 52px;
  /* height: 380px; */
  border-radius: 10px;
}

.stuLead ::v-deep .el-dialog__title {
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.stuLead ::v-deep .el-dialog__header {
  padding: 0;
  margin-bottom: 30px;
}

.stuLead ::v-deep .el-dialog__body {
  padding: 0;
}

.xzbtn {
  margin-top: 25px;
  margin-left: 64px;
  width: 200px;
  height: 40px;
  background: #0b8586;
  border-radius: 18px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.importItem {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.StuLeadResults ::v-deep .el-dialog {
  padding: 50px 52px;
  height: 660px;
  border-radius: 10px;
}

.StuLeadResults ::v-deep .el-dialog__title {
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.StuLeadResults ::v-deep .el-dialog__header {
  padding: 0;
  margin-bottom: 30px;
}

.StuLeadResults ::v-deep .el-dialog__body {
  padding: 0;
}

.StuLeadResults ::v-deep td {
  padding: 8px 0 !important;
}

.StuLeadResults ::v-deep .cell {
  text-align: center;
}

.SLRTitle {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgb(226, 226, 226);
  border-bottom: 4px solid rgb(207, 207, 207);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #eee;
}

.SLRTitle div {
  width: 50%;
  text-align: center;
  cursor: pointer;
}

.Join ::v-deep .el-dialog {
  height: 259px;
}

.ProDetail ::v-deep .el-dialog {
  height: auto;
  padding: 25px 30px;
}

.ProDetail p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
}

.ProDetail .pagination_Wrap {
  margin: 15px 0;
}

.ProDetail ::v-deep .el-dialog__header {
  margin-bottom: 0px;
}

.ProDetail .nolist {
  text-align: center;
  line-height: 100px;
}

.stuLeadInfoBtn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.stuLeadInfoBtn .xzbtn {
  margin-left: 20px;
  margin-right: 20px;
  width: 160px;
  height: 36px;
  line-height: 34px;
  border-radius: 17px;
  border: 1px solid #0b8586;
}

.StuLeadResults ::v-deep .warning-row {
  background: rgba(255, 55, 55, 0.206);
}

.StuLeadResults ::v-deep.el-table tbody tr:hover>td {
  background-color: unset;
}

.fenye {
  display: flex;
  justify-content: center;
  padding: 35px 0;
}

.fenye ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #fff;
  background-color: #0b8586;
}
</style>